<!-- Search Component With Popup Inputs -->

<template>
	<div class="search-layout">

		<div class="title wi8_font">Search for Articles</div>

		<div class="v-spacer"/>

		<div class="label-box">Category:</div>
		<div class="value-box">
			<CatPickBtn 
				:step="step"
			/>
		</div>
		<div class="btn-clear" @click="clickClearCat">
			<UniIcon ico="cancel" fit="1" pad="5" color="#C30" />
		</div>

		<div class="v-spacer"/>

		<div class="label-box">Keyword:</div>
		<div class="pop-value-box" @click="popInput('keyword')" v-html="rec.keyword"></div>

		<div class="btn-clear" @click="clickClear('keyword')">
			<UniIcon ico="cancel" fit="1" pad="5" color="#C30" />
		</div>

		<div class="v-spacer"/>

		<!-- Begin Date -->
		<div class="label-box">Beg Date:</div>
		<div class="pop-value-box" @click="popInput('dateBeg')" v-html="convertLFs(rec.dateBeg)"></div>

		<div class="btn-clear" @click="clickClear('dateBeg')">
			<UniIcon ico="cancel" fit="1" pad="5" color="#C30" />
		</div>

		<div class="v-spacer"/>

		<!-- End Date -->
		<div class="label-box">End Date:</div>
		<div class="pop-value-box" @click="popInput('dateEnd')" v-html="convertLFs(rec.dateEnd)"></div>

		<div class="btn-clear" @click="clickClear('dateEnd')">
			<UniIcon ico="cancel" fit="1" pad="5" color="#C30" />
		</div>

		<div class="v-spacer"/>  

		<div class="bottom-box">
			<button class="btn-search wi8_font" @click="clickSearch">Search!</button>
		</div>

<!-- 
		<div class="bottom-box">
			<button class="btn-search wi8_font" @click="goTest">Test!</button>
		</div> 
 -->

	</div>
</template>

<script>
import { m } from "@/utils/utils"
import * as Utils from "@/utils/utils";
import CfgApp from "@/assets/cfg/CfgApp";
import { mapState } from 'vuex';
import { eventBus } from '@/main';

export default {
  	data() {
		return {
			step: "search",
			rec: {
				keyword: "",
				dateBeg: "",
				dateEnd: "",
			},
		};
	},
	computed: {
		...mapState('app', ['search']),
	},
	methods: {
		goTest() {
			m("go test");
		},
		popInput(colName) {
			this.showComp = false;
			Utils.showPopInput(colName, this.rec[colName]);
		},
		handleUpdateVal(payload) {
			m("handle update", payload);
			this.showComp = true;
			let colName = payload.colName || "dateBeg";
			let val = payload.val;
			this.rec[colName] = val;
			m("rec is now", this.rec);
		},
		convertLFs(str1="") {
			let str2 = str1.replace(/\n/g, '<br/>', );
			return str2;
		},
		clickClearCat() {
			m("click clear cat");
			let data = {
				step: this.step,
			}
			this.$store.dispatch('app/setCat', data);
		},
		clickClear(key) {
			m("click clear", key);
			if (key=="keyword") this.rec.keyword = '';
			if (key=="dateBeg") this.rec.dateBeg = "";
			if (key=="dateEnd") this.rec.dateEnd = "";
		},
		prepareSaveSearch() {
			m("prepare save search");
			const payload = {
				cat: this.search.cat,
				keyword: this.rec.keyword,
				dateBeg: this.rec.dateBeg,
				dateEnd: this.rec.dateEnd,
			}
			return payload;
		},
		clickSearch() {
			m("click search");
			if (this.validated()) {
				const payload = this.prepareSaveSearch();
				this.$store.dispatch('app/setSearch', payload)
					.then (this.$store.dispatch('app/setSearchResult', payload))
					.then (this.$store.dispatch('app/reqArticles'))
					.then (this.$router.push('/arts'))
			} else {
				let messText = [
					`Begin Date ${this.rec.dateBeg}`,
					"is later than ",
					`End Date ${this.rec.dateEnd}`,
				];
				let payload = {
					popType: "win",
					popTitle: "Oops! Invalid dates",
					compName: "UniMess",
					compData: {
						title: "Please correct the search dates",
						messType: "err",
						mess: messText,
					}
				};
				eventBus.$emit("popup", payload);			
			}
		},
		validated() {
			let answer = true;
			if (this.rec.dateBeg != "" && this.rec.dateEnd != "") {
				if (this.rec.dateBeg > this.rec.dateEnd) {
					answer = false;
					m("bad dates");
				}
			}

			m("validated", answer);
			return answer;
		},
		clickShowCatPopup() {
			m("click set cat");
			let payload = {
				popType: "door",
				popTitle: "Choose Category",
				popText: "This is the door text.",
				compName: "CatPick",
				compData: {},
			};
			eventBus.$emit("popup", payload);			
		},
	},
	created() {
		m("search created");
		eventBus.$emit('popoffall'); // Close all modal windows
		this.rec.keyword = this.search.keyword;
		this.rec.dateBeg = this.search.dateBeg;
		this.rec.dateEnd = this.search.dateEnd;
		eventBus.$on('update-value', this.handleUpdateVal);
	},
	beforeDestroy() {
		m("before destroy");
		eventBus.$off('update-value', this.handleUpdateVal);
		// Remember Search Values
		const payload = this.prepareSaveSearch();
		this.$store.dispatch('app/setSearch', payload)
	},
	mounted() {
		m("search mounted", this.search);
	},
}
</script>

<style scoped>

.search-layout {
	height: 100%;
	background-color: #F6F6F6;
	border: solid 0px #C30;
}

.title {
	height: 40px;
	overflow: hidden;
	padding: 10px 0px 0px 90px;
	color:#369;
	border: solid 0px #090;
}

.label-box {
	display: inline-block;
	width: 90px;
	height: 40px;
	overflow: hidden;
	vertical-align: top;
	text-align: right;
	padding: 5px 10px 0px 0px;
	border: solid 0px #369;
}

.value-box {
	display: inline-block;
	width: 190px;
	height: 50px;
	overflow: hidden;
	vertical-align: top;
	border: solid 0px #090;
}

.pop-value-box {
	display: inline-block;
	width: 190px;
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	cursor: pointer;
	background-color: #FFF;
	border: solid 1px #999;
}

.pop-textarea {
	width: 180px;
}

.btn-search {
	width: 120px;
	height: 30px;
	color: #369;
}

.btn-clear {
	display: inline-block;
	width: 50px;
	height: 36px;
	overflow: hidden;
	vertical-align: top;
	cursor: pointer;
	border: solid 0px #090;
}

.v-spacer {
	width: 20px;
	height: 20px;
	border: solid 0px #000;
}

.bottom-box {
	height: 50px;
	overflow: hidden;
	padding: 10px 0px 0px 90px;
	color:#369;
	border: solid 0px #C30;
}

</style>
